<template>
  <div class="about" style="font-size: 18px;">
    <!-- <el-form ref="form" :inline="true" :model="form" label-width="80px">
      <el-form-item label="Structure">
        <el-col :span="11">
          <el-input
            type="textarea"
            style="width: 400px"
            :autosize="{ minRows: 2, maxRows: 10 }"
            v-model.trim="form.structure"
          ></el-input>
        </el-col>
        <el-col>
          <el-upload
            class="upload-demo"
            action="/api/uploader"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :on-exceed="handleExceed"
            :on-success="onSuccess"
            :file-list="fileList"
            :multiple="false"
            :limit="1"
          >
            <el-button size="small">mol2/SDF Uplade</el-button>
          </el-upload>
        </el-col>
      </el-form-item>
      <el-form-item label="Name">
        <el-input v-model.trim="form.name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >Search</el-button
        >
      </el-form-item> -->
    <!-- </el-form> -->
    <el-table
      :data="showData"
      v-loading="loading"
      stripe
      border
      fit
      style="width: 100%"
      empty-text="No Data"
    >
      <!-- <el-table-column type="index"> </el-table-column>
      <el-table-column prop="NP_ChEMBL_ID" label="NP_ChEMBL_ID"> -->
        <!-- <template slot-scope="scope">
          <el-link type="primary" @click="toDetail(scope.row.id)">{{
            scope.row.id
          }}</el-link> -->
        <!-- </template> -->
      <!-- </el-table-column> -->
      <!-- <el-table-column prop="Activ_type" label="Activ_type"> </el-table-column>
      <el-table-column prop="Activ_Value" label="Activ_value"> </el-table-column>
      <el-table-column prop="Units" label="Units"></el-table-column>
      <el-table-column prop="Reference" label="Reference"></el-table-column>
      <el-table-column prop="Assay_ChEMBL_ID" label="Assay_ChEMBL_ID"></el-table-column>
      <el-table-column prop="Assay" label="Assay"></el-table-column> -->
      <el-table-column prop="Inflam_id" label="Inflam_id" width="100px">
		  <template slot-scope="scope">
		  	<el-link type="primary" @click="toDetail(scope.row.IID)">{{scope.row.Inflam_id}}</el-link>
		  </template>
	  </el-table-column>
      <el-table-column prop="`Name`" label="Name"></el-table-column>
      <el-table-column prop="NP_ChEMBL_ID" label="NP_ChEMBL_ID" width="150px"></el-table-column>
      <el-table-column prop="Target_ChEMBL_ID" label="Target_ChEMBL_ID" width="160px"></el-table-column>
      <el-table-column prop="Activ_type" label="Activ_type" width="100px"></el-table-column>
      <el-table-column prop="Activ_Value" label="Activ_Value" width="100px"></el-table-column>
      <el-table-column prop="Units" label="Units"></el-table-column>
      <el-table-column prop="Ref_info" label="Ref_info" width="600px"></el-table-column>
        <!-- <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.img"
            fit="fill"
          ></el-image>
        </template> -->
      
      <!-- <el-table-column fixed="right" label="detail">
        <template slot-scope="scope">
          <el-button
            icon="el-icon-share"
            @click="toDetail(scope.row.id)"
            type="text"
            size="small"
            >Detail</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <div class="page-warp">
      <el-pagination
        @current-change="currentChange"
        background
        layout="prev, pager, next"
        :total="tableData.length"
      />
    </div>
    <!-- <div class="down-load">
      <el-button size="small" @click="down" type="success" round
        >Download</el-button
      >
    </div> -->
    <iframe v-show="false" :src="iframeurl" frameborder="0"></iframe>
  </div>
</template>
<script>
export default {
  name: "about",
  data() {
    return {
      info: {
        exinfo:{},
      },  
      tableData: [],
      currentNum: 1,
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    showData() {
      let tableList = this.tableData.concat([]);
      return tableList.slice((this.currentNum - 1) * 10, this.currentNum * 10);
    },
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.currentNum = 1;
      this.tableData = [];
      this.$http({
        url: "/api/rdkit/queryBySmiles",
        params: this.form,
        method: "get",
      }).then((res) => {
        this.tableData = res.data.data;
        if (!this.tableData.length) {
          this.$message.warning("No compound matched");
        }
        this.loading = false;
      });
    },
    currentChange(num) {
      this.currentNum = num;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      // this.$message.warning(
      //   `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
      //     files.length + fileList.length
      //   } 个文件`
      // );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Sure to remove ${file.name}？`);
    },
    onSuccess({ data }) {
      this.form.structure = data.join(",");
    },
    down() {
      const { structure, name } = this.form;
      this.iframeurl = `/api/exportCsv?structure=${structure}&name=${name}`;
    },
    toDetail(id) {
    	const {
    		origin,
    		pathname
    	} = window.location;
    	window.location.href = `${origin}${pathname}#/main/search/detail?id=${id}`;
    	//   window.open(`${origin}${pathname}#/main/search/detail?id=${id}`);
    },
  },
  mounted() {
    this.$http({
      url: "/api/rdkit/queryTarExInfoById",
      params: {
        id: this.$route.query.id,
      },
    }).then((res) => {
      this.tableData = res.data.data;
    });
  },
};
</script>

<style scoped>
  .page-warp {
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .down-load {
    display: flex;
    justify-content: flex-end;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .about {
    padding:0 100px;
    margin: 0 auto;
  }
</style>

<!--<template>-->
<!--  <div class="about">-->
    <!-- <el-form ref="form" :inline="true" :model="form" label-width="80px">
<!--      <el-form-item label="Structure">-->
<!--        <el-col :span="11">-->
<!--          <el-input-->
<!--            type="textarea"-->
<!--            style="width: 400px"-->
<!--            :autosize="{ minRows: 2, maxRows: 10 }"-->
<!--            v-model.trim="form.structure"-->
<!--          ></el-input>-->
<!--        </el-col>-->
<!--        <el-col>-->
<!--          <el-upload-->
<!--            class="upload-demo"-->
<!--            action="/api/uploader"-->
<!--            :on-preview="handlePreview"-->
<!--            :on-remove="handleRemove"-->
<!--            :before-remove="beforeRemove"-->
<!--            :on-exceed="handleExceed"-->
<!--            :on-success="onSuccess"-->
<!--            :file-list="fileList"-->
<!--            :multiple="false"-->
<!--            :limit="1"-->
<!--          >-->
<!--            <el-button size="small">mol2/SDF Uplade</el-button>-->
<!--          </el-upload>-->
<!--        </el-col>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="Name">-->
<!--        <el-input v-model.trim="form.name"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item>-->
<!--        <el-button type="primary" icon="el-icon-search" @click="onSubmit"-->
<!--          >Search</el-button-->
<!--        >-->
<!--      </el-form-item> -->-->
    <!-- </el-form> -->
<!--    <el-table-->
<!--      :data="showData"-->
<!--      v-loading="loading"-->
<!--      stripe-->
<!--      border-->
<!--      fit-->
<!--      style="width: 100%"-->
<!--      empty-text="No Data"-->
<!--    >-->
<!--      <el-table-column type="index"> </el-table-column>-->
<!--      <el-table-column prop="NP_ChEMBL_ID" label="NP_ChEMBL_ID">-->
        <!-- <template slot-scope="scope">
<!--          <el-link type="primary" @click="toDetail(scope.row.id)">{{-->
<!--            scope.row.id-->
<!--          }}</el-link> -->-->
        <!-- </template> -->
<!--      </el-table-column>-->
<!--      <el-table-column prop="Activ_type" label="Activ_type"> </el-table-column>-->
<!--      <el-table-column prop="Activ_Value" label="Activ_value"> </el-table-column>-->
<!--      <el-table-column prop="Units" label="Units"></el-table-column>-->
<!--      <el-table-column prop="Reference" label="Reference"></el-table-column>-->
<!--      <el-table-column prop="Assay_ChEMBL_ID" label="Assay_ChEMBL_ID"></el-table-column>-->
<!--      <el-table-column prop="Assay" label="Assay"></el-table-column>-->
        <!-- <template slot-scope="scope">
<!--          <el-image-->
<!--            style="width: 100px; height: 100px"-->
<!--            :src="scope.row.img"-->
<!--            fit="fill"-->
<!--          ></el-image>-->
<!--        </template> -->-->
      
      <!-- <el-table-column fixed="right" label="detail">
<!--        <template slot-scope="scope">-->
<!--          <el-button-->
<!--            icon="el-icon-share"-->
<!--            @click="toDetail(scope.row.id)"-->
<!--            type="text"-->
<!--            size="small"-->
<!--            >Detail</el-button-->
<!--          >-->
<!--        </template>-->
<!--      </el-table-column> -->-->
<!--    </el-table>-->
<!--    <div class="page-warp">-->
<!--      <el-pagination-->
<!--        @current-change="currentChange"-->
<!--        background-->
<!--        layout="prev, pager, next"-->
<!--        :total="tableData.length"-->
<!--      />-->
<!--    </div>-->
    <!-- <div class="down-load">
<!--      <el-button size="small" @click="down" type="success" round-->
<!--        >Download</el-button-->
<!--      >-->
<!--    </div> -->-->
<!--    <iframe v-show="false" :src="iframeurl" frameborder="0"></iframe>-->
<!--  </div>-->
<!--</template>-->
<!--<script>-->
<!--export default {-->
<!--  name: "about",-->
<!--  data() {-->
<!--    return {-->
<!--      info: {-->
<!--        exinfo:{},-->
<!--      },  -->
<!--      tableData: [],-->
<!--      currentNum: 1,-->
<!--    };-->
<!--  },-->
<!--  computed: {-->
<!--    id() {-->
<!--      return this.$route.query.id;-->
<!--    },-->
<!--    showData() {-->
<!--      let tableList = this.tableData.concat([]);-->
<!--      return tableList.slice((this.currentNum - 1) * 10, this.currentNum * 10);-->
<!--    },-->
<!--  },-->
<!--  methods: {-->
<!--    onSubmit() {-->
<!--      this.loading = true;-->
<!--      this.currentNum = 1;-->
<!--      this.tableData = [];-->
<!--      this.$http({-->
<!--        url: "/api/rdkit/queryBySmiles",-->
<!--        params: this.form,-->
<!--        method: "get",-->
<!--      }).then((res) => {-->
<!--        this.tableData = res.data.data;-->
<!--        if (!this.tableData.length) {-->
<!--          this.$message.warning("No compound matched");-->
<!--        }-->
<!--        this.loading = false;-->
<!--      });-->
<!--    },-->
<!--    currentChange(num) {-->
<!--      this.currentNum = num;-->
<!--    },-->
<!--    handleRemove(file, fileList) {-->
<!--      console.log(file, fileList);-->
<!--    },-->
<!--    handlePreview(file) {-->
<!--      console.log(file);-->
<!--    },-->
<!--    handleExceed(files, fileList) {-->
      <!--// this.$message.warning(-->
      <!--//   `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${-->
      <!--//     files.length + fileList.length-->
      <!--//   } 个文件`-->
      <!--// );-->
<!--    },-->
<!--    beforeRemove(file, fileList) {-->
<!--      return this.$confirm(`Sure to remove ${file.name}？`);-->
<!--    },-->
<!--    onSuccess({ data }) {-->
<!--      this.form.structure = data.join(",");-->
<!--    },-->
<!--    down() {-->
<!--      const { structure, name } = this.form;-->
<!--      this.iframeurl = `/api/exportCsv?structure=${structure}&name=${name}`;-->
<!--    },-->
<!--    toDetail(id) {-->
<!--      const { origin, pathname } = window.location;-->
<!--      window.open(`${origin}${pathname}#/main/search/detail?id=${id}`);-->
<!--    },-->
<!--  },-->
<!--  mounted() {-->
<!--    this.$http({-->
<!--      url: "/api/rdkit/queryTarExInfoById",-->
<!--      params: {-->
<!--        id: this.$route.query.id,-->
<!--      },-->
<!--    }).then((res) => {-->
<!--      this.tableData = res.data.data;-->
<!--    });-->
<!--  },-->
<!--};-->
<!--</script>-->

<!--<style scoped>-->
<!--  .page-warp {-->
<!--    margin-top: 10px;-->
<!--    display: flex;-->
<!--    justify-content: center;-->
<!--  }-->
<!--  .down-load {-->
<!--    display: flex;-->
<!--    justify-content: flex-end;-->
<!--  }-->
<!--  .demo-table-expand {-->
<!--    font-size: 0;-->
<!--  }-->
<!--  .demo-table-expand label {-->
<!--    width: 90px;-->
<!--    color: #99a9bf;-->
<!--  }-->
<!--  .demo-table-expand .el-form-item {-->
<!--    margin-right: 0;-->
<!--    margin-bottom: 0;-->
<!--    width: 50%;-->
<!--  }-->
<!--  .about {-->
<!--    width: 1200px;-->
<!--    margin: 0 auto;-->
<!--  }-->
<!--</style>-->